module.exports = __webpack_public_path__ + "static/media/fa-regular-400.d30b8018.eot";